import { requestApi } from '../util/network'

// 创建token
export const createToken =
  () =>
    requestApi(
      '/token/create',
      'POST',
      {
      },
      'member'
    )

export const getWithdrawList =
  (params) =>
    requestApi(
      '/Memberfund/pdcashlist',
      'POST',
      {
        page: params.page,
        per_page: params.per_page
      },
      'member'
    )
export const addWithdraw =
  (pdcAmount, memberbankId, password, form_token) =>
    requestApi(
      '/Recharge/pd_cash_add',
      'POST',
      {
        pdc_amount: pdcAmount,
        memberbank_id: memberbankId,
        password: password,
        form_token: form_token
      },
      'member'
    )
